import { useEffect, useState } from "react";

export const useSentry = () => {
  const [Sentry, setSentry] = useState(null);

  useEffect(() => {
    import("@sentry/react").then((sentry) => {
      setSentry(sentry);
    });
  }, []);

  const init = () => {
    if (process.env.NODE_ENV === "production") {
      Sentry?.init({
        dsn: "https://c2425e2792144313902476d086dd7e91@o383741.ingest.sentry.io/4505120977846272",
        integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
        tracesSampleRate: 0.1,
      });
    }
  };

  return {
    init,
  };
};
